module.exports = __webpack_public_path__ + "static/media/order.e230306a.svg";